// @import dependencies
import React, { CSSProperties, useState, useEffect } from 'react'
// @end dependencies

// @import components
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { Carousel } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// @end components

// @import types
import { IBanner } from 'app_types/campus/banner/bannerTypes';
// @end types

// @import services
import BannerService from 'app_services/campus/banner/bannerService'
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './LandingCarousel.scss'
// @end styles

interface ILandingCarouselProps {
  className?: string
  classNameItem?: string
  style?: CSSProperties
  styleItem?: CSSProperties
  id?: string
  onlyAvailable?: boolean
}

const LandingCarousel: React.FC<ILandingCarouselProps> = (props) => {
  const [banners, updateBanners] = useState<IBanner[]>([])

    // @INFO Servicios
    const bannerService = new BannerService()

    useEffect(() => {
        getBanners()
    }, [])

    // @INFO Obtener la lista de banners
    const getBanners = async () => {
        let httpParams: any = {
          pageNumber: 1,
          nPerPage: 7,
          isActive: true,
          locations: ['student_landing']
        }
        const _banners = await bannerService.fetchBanners(httpParams)
        if (_banners && _banners.banners) {
          updateBanners(_banners.banners);
        }
    }

    return(
        banners.length ?
            <Carousel
                className={`home_carousel-layout ${props.className ? props.className : ''}`}
                style={props.style}
                nextLabel={''}
                prevLabel={''}
                // activeIndex={0}
                onChange={() => {}}
                id={props.id}
                controls={false}
            >
                {banners?.length ?
                    banners.map((banner) => (
                      <Carousel.Item style={{backgroundImage: `url(${banner.coverUrl})`}} key={banner.key}>
                        <Carousel.Caption>
                          <div className="text-caption">
                            <div className='text-caption-header'>
                              <OverlayTrigger
                                trigger={['hover', 'focus']}
                                placement={'top'}
                                overlay={
                                  <Tooltip id='toolip-circle'>
                                    {banner.title}
                                  </Tooltip>
                                }>
                                <h3>{banner.title}</h3>
                              </OverlayTrigger>
                            </div>
                            <div className="text-caption-body">
                              <OverlayTrigger
                                trigger={['hover', 'focus']}
                                placement={'top'}
                                overlay={
                                  <Tooltip id='toolip-circle'>
                                    {banner.content}
                                  </Tooltip>
                                }>
                                <p className="banner-content">{banner.content}</p>
                              </OverlayTrigger>
                              {banner?.action || banner?.registerUrl ?
                                <div className="action-container">
                                  {banner?.action ? (
                                    <Link
                                        to={{
                                            pathname: banner.action
                                        }}
                                        target='_blank'
                                    >
                                      Más información
                                    </Link>
                                  ): null}
                                  {banner?.registerUrl ? (
                                    <Link
                                        to={{
                                            pathname: banner.registerUrl
                                        }}
                                        target='_blank'
                                    >
                                      Registro
                                    </Link>
                                  ): null}
                                </div>
                              :null}
                            </div>
                          </div>

                          {/* <ol className="carousel-indicators">
                            {banners.map((item, index) => {
                              return (
                                <li
                                  key={index}
                                  onClick={() => props.goToIndex(index)}
                                  className={(props.activeIndex === index) ? 'active': ''}
                                />
                              );
                            })}
                          </ol> */}
                        </Carousel.Caption>
                      </Carousel.Item>
                        // <Carousel.Item
                        //     className={`item-carousel-home ${props.classNameItem ? props.classNameItem : ''}`}
                        //     style={props.styleItem}
                        //     key={_item?._id}
                        // >
                        //     <img
                        //         src={_item.coverUrl}
                        //         alt='prueba'
                        //     />
                        //     <div className="container-info-banner">
                        //         <TextComponent
                        //             style={{ color: 'white' }}
                        //             type='title'
                        //         >
                        //             {_item.title}
                        //         </TextComponent>
                        //         <TextComponent
                        //             style={{ color: 'white' }}
                        //             type='text'
                        //         >
                        //             {_item.content}
                        //         </TextComponent>
                        //         {_item?.action ?
                        //             <Link
                        //                 to={{
                        //                     pathname: _item.action
                        //                 }}
                        //                 target='_blank'
                        //             >
                        //                 <ButtonComponent
                        //                     className='button-banner-action'
                        //                     variant='tertiary'
                        //                 >
                        //                     Más información
                        //                 </ButtonComponent>
                        //             </Link>
                        //         :null}
                        //     </div>
                        // </Carousel.Item>
                    ))
                :null}
            </Carousel>
        :
        null
    );
}

export default LandingCarousel;
